import {
    TableCell as MuiTableCell,
    styled,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { SegmentationData } from '~/hooks/workflows/backend/tasks/useSegmentationMetrics';

type SegmentationTableProps = {
    data: SegmentationData[];
};

const TableCell = styled(MuiTableCell)(({ theme }) => ({
    fontSize: 12,
    padding: '6px 12px',
    borderBottom: `1px solid ${theme.palette.divider}`,
}));

const SegmentationTable = ({ data }: SegmentationTableProps) => {
    const transformedData = data.map((item) => {
        const testVolume = (item.user_vol_mm3 / 1000).toFixed(2);
        const referenceVolume = (item.gt_vol_mm3 / 1000).toFixed(2);
        const volumeDifference = (
            ((item.user_vol_mm3 - item.gt_vol_mm3) / item.gt_vol_mm3) *
            100
        ).toFixed(1);
        return {
            structure: item.gt_roi_name,
            testVolume,
            referenceVolume,
            volumeDifference,
            dsc: item.dice.toFixed(3),
            sDsc: item.sdice2.toFixed(3),
            hd95: item.hd95.toFixed(1),
        };
    });

    return (
        <TableContainer
            sx={(theme) => ({
                maxHeight: 220,
                width: 840,
                overflowY: 'auto',
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: `${theme.shape.borderRadius}px`,
            })}
        >
            <Table stickyHeader>
                <TableHead>
                    <TableRow sx={{ fontSize: 12 }}>
                        <TableCell>Structure</TableCell>
                        <TableCell>Test Volume (cm³)</TableCell>
                        <TableCell>Reference Volume (cm³)</TableCell>
                        <TableCell>Volume Difference (%)</TableCell>
                        <TableCell>DSC</TableCell>
                        <TableCell>S-DSC (@2mm)</TableCell>
                        <TableCell>HD95 (mm)</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {transformedData.map((row) => (
                        <TableRow key={row.structure}>
                            <TableCell>{row.structure}</TableCell>
                            <TableCell>{row.testVolume}</TableCell>
                            <TableCell>{row.referenceVolume}</TableCell>
                            <TableCell>{row.volumeDifference}</TableCell>
                            <TableCell>{row.dsc}</TableCell>
                            <TableCell>{row.sDsc}</TableCell>
                            <TableCell>{row.hd95}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SegmentationTable;
